import React from "react";
import { T } from "./atoms";

// Ticket sources, status mapping and actions remain with each adapter.
// This table frame is shared by the live support list and fictional demo list.
export default function TicketTable({ headers, children, headerStyle }) {
  const thStyle = headerStyle || {
    textAlign:"left", padding:8, borderBottom:`1px solid ${T.border}`, color:T.muted,
  };
  return <table style={{ width:"100%", borderCollapse:"collapse" }}>
    <thead><tr>{headers.map(label => <th key={label} style={thStyle}>{label}</th>)}</tr></thead>
    <tbody>{children}</tbody>
  </table>;
}
